import { HandlerEvent } from 'post-robot';
import { error } from 'common/errors';
import { getIsFeatureToggleEnabled } from 'communicator/store/selectors';
import { ValidationError } from 'exports';
import { SpawnAuthProxy } from 'types/visa-sdk/authenticate';

export default async function spawnAuthProxy(
  event: HandlerEvent<SpawnAuthProxy>
): Promise<ValidationError | void> {
  if (getIsFeatureToggleEnabled('enableIssuerAppAuth')) {
    return event.data.launchAuthProxy();
  }

  return error('AUTH_ERROR', 'Authentication method not supported.');
}
